module.exports = __webpack_public_path__ + "img/video-call.6f8a5c07.svg";